//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v14.7.1.0 (NJsonSchema v11.6.1.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* eslint-disable */
// ReSharper disable InconsistentNaming

export class AuthorizedApiBase {
  private readonly config: IConfig;

  constructor(config: IConfig) {
    this.config = config;
  }

  protected transformOptions = (options: RequestInit): Promise<RequestInit> => {
    const authorizationHeaderValue = this.config.getAuthorization();

    if(authorizationHeaderValue !== null && authorizationHeaderValue !== undefined){
      // Update headers to add the JWT Token
      options.headers = {
        ...options.headers,
        Authorization: authorizationHeaderValue,
      };
    }

    return Promise.resolve(options);
  };

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  protected transformResult(url: string, response: Response, processor: (response: Response) => any) {

    if (response.status === 401) {
      console.warn(`Unauthorised API call url=${response.url}`);

      // Logout
      this.config.onLogout();
    }

    return processor(response);
  }
}

export class AccountClient extends AuthorizedApiBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: IConfig, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @return OK
     */
    login(body: LoginRequest): Promise<LoginResponse> {
        let url_ = this.baseUrl + "/login";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processLogin(_response));
        });
    }

    protected processLogin(response: Response): Promise<LoginResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = LoginResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<LoginResponse>(null as any);
    }

    /**
     * @return OK
     */
    verifyIdNumber(body: VerifyIdNumberRequest): Promise<VerifyIdNumberResponse> {
        let url_ = this.baseUrl + "/login-with-otp/verify-id-number";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processVerifyIdNumber(_response));
        });
    }

    protected processVerifyIdNumber(response: Response): Promise<VerifyIdNumberResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = VerifyIdNumberResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<VerifyIdNumberResponse>(null as any);
    }

    /**
     * @return OK
     */
    loginWithOtp(body: LoginWithOtpRequest): Promise<LoginWithOtpResponse> {
        let url_ = this.baseUrl + "/login-with-otp/verify-otp";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processLoginWithOtp(_response));
        });
    }

    protected processLoginWithOtp(response: Response): Promise<LoginWithOtpResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = LoginWithOtpResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<LoginWithOtpResponse>(null as any);
    }

    /**
     * @return OK
     */
    registerCustomer(body: RegisterCustomerRequest): Promise<RegisterCustomerResponse> {
        let url_ = this.baseUrl + "/register/customer";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processRegisterCustomer(_response));
        });
    }

    protected processRegisterCustomer(response: Response): Promise<RegisterCustomerResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = RegisterCustomerResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<RegisterCustomerResponse>(null as any);
    }

    /**
     * @return OK
     */
    registerWithCustomerDetails(body: RegisterCustomerWithDetailsRequest): Promise<RegisterCustomerWithDetailsResponse> {
        let url_ = this.baseUrl + "/register-with-customer-details";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processRegisterWithCustomerDetails(_response));
        });
    }

    protected processRegisterWithCustomerDetails(response: Response): Promise<RegisterCustomerWithDetailsResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = RegisterCustomerWithDetailsResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<RegisterCustomerWithDetailsResponse>(null as any);
    }

    /**
     * @return OK
     */
    changePassword(body: ChangePasswordRequest): Promise<ChangePasswordResponse> {
        let url_ = this.baseUrl + "/account/change-password";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processChangePassword(_response));
        });
    }

    protected processChangePassword(response: Response): Promise<ChangePasswordResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ChangePasswordResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ChangePasswordResponse>(null as any);
    }

    /**
     * @return OK
     */
    resetPassword(body: GenerateResetPasswordPinRequest): Promise<GenerateResetPasswordPinResponse> {
        let url_ = this.baseUrl + "/authentication/reset-password";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processResetPassword(_response));
        });
    }

    protected processResetPassword(response: Response): Promise<GenerateResetPasswordPinResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GenerateResetPasswordPinResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GenerateResetPasswordPinResponse>(null as any);
    }

    /**
     * @return OK
     */
    confirmPasswordReset(body: ConfirmPasswordResetRequest): Promise<ConfirmPasswordResetResponse> {
        let url_ = this.baseUrl + "/authentication/confirm-password-reset";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processConfirmPasswordReset(_response));
        });
    }

    protected processConfirmPasswordReset(response: Response): Promise<ConfirmPasswordResetResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ConfirmPasswordResetResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ConfirmPasswordResetResponse>(null as any);
    }

    /**
     * @return OK
     */
    resetPasswordV2(body: GenerateForgotPasswordPinRequest): Promise<GenerateForgotPasswordPinResponse> {
        let url_ = this.baseUrl + "/authentication/forgot-password";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processResetPasswordV2(_response));
        });
    }

    protected processResetPasswordV2(response: Response): Promise<GenerateForgotPasswordPinResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GenerateForgotPasswordPinResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GenerateForgotPasswordPinResponse>(null as any);
    }

    /**
     * @return OK
     */
    completeForgotPassword(body: CompleteForgotPasswordRequest): Promise<CompleteForgotPasswordResponse> {
        let url_ = this.baseUrl + "/authentication/complete-forgot-password";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processCompleteForgotPassword(_response));
        });
    }

    protected processCompleteForgotPassword(response: Response): Promise<CompleteForgotPasswordResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CompleteForgotPasswordResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CompleteForgotPasswordResponse>(null as any);
    }

    /**
     * @return OK
     */
    checkPasswordVerificationOtpValidity(body: CheckPasswordVerificationOtpValidityRequest): Promise<CheckPasswordVerificationOtpValidityResponse> {
        let url_ = this.baseUrl + "/authentication/check-otp-validity/password";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processCheckPasswordVerificationOtpValidity(_response));
        });
    }

    protected processCheckPasswordVerificationOtpValidity(response: Response): Promise<CheckPasswordVerificationOtpValidityResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CheckPasswordVerificationOtpValidityResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CheckPasswordVerificationOtpValidityResponse>(null as any);
    }

    /**
     * @return OK
     */
    resetEmail(body: GenerateChangeEmailPinRequest): Promise<GenerateChangeEmailPinResponse> {
        let url_ = this.baseUrl + "/authentication/reset-email";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processResetEmail(_response));
        });
    }

    protected processResetEmail(response: Response): Promise<GenerateChangeEmailPinResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GenerateChangeEmailPinResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GenerateChangeEmailPinResponse>(null as any);
    }

    /**
     * @return OK
     */
    confirmEmailReset(body: ConfirmEmailChangeRequest): Promise<ConfirmEmailChangeResponse> {
        let url_ = this.baseUrl + "/authentication/confirm-email-reset";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processConfirmEmailReset(_response));
        });
    }

    protected processConfirmEmailReset(response: Response): Promise<ConfirmEmailChangeResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ConfirmEmailChangeResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ConfirmEmailChangeResponse>(null as any);
    }

    /**
     * @return OK
     */
    refreshToken(): Promise<RefreshTokenResponse> {
        let url_ = this.baseUrl + "/account/refresh-token";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processRefreshToken(_response));
        });
    }

    protected processRefreshToken(response: Response): Promise<RefreshTokenResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = RefreshTokenResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<RefreshTokenResponse>(null as any);
    }

    /**
     * @return OK
     */
    getPersonalDetails(): Promise<GetPersonalDetailsResponse> {
        let url_ = this.baseUrl + "/account/personal-details";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetPersonalDetails(_response));
        });
    }

    protected processGetPersonalDetails(response: Response): Promise<GetPersonalDetailsResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetPersonalDetailsResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GetPersonalDetailsResponse>(null as any);
    }

    /**
     * @return OK
     */
    updatePersonalDetails(body: PersonalDetails): Promise<UpdatePersonalDetailsResponse> {
        let url_ = this.baseUrl + "/account/personal-details";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processUpdatePersonalDetails(_response));
        });
    }

    protected processUpdatePersonalDetails(response: Response): Promise<UpdatePersonalDetailsResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UpdatePersonalDetailsResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ErrorResponse.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<UpdatePersonalDetailsResponse>(null as any);
    }

    /**
     * @return OK
     */
    getCustomer(): Promise<GetCustomerResponse> {
        let url_ = this.baseUrl + "/account/customer";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetCustomer(_response));
        });
    }

    protected processGetCustomer(response: Response): Promise<GetCustomerResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetCustomerResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GetCustomerResponse>(null as any);
    }

    /**
     * @return OK
     */
    updateCustomer(body: CustomerDetails): Promise<UpdateCustomerResponse> {
        let url_ = this.baseUrl + "/account/customer";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processUpdateCustomer(_response));
        });
    }

    protected processUpdateCustomer(response: Response): Promise<UpdateCustomerResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UpdateCustomerResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ErrorResponse.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<UpdateCustomerResponse>(null as any);
    }

    /**
     * @return OK
     */
    getBankAccount(): Promise<GetBankResponse> {
        let url_ = this.baseUrl + "/account/bank";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetBankAccount(_response));
        });
    }

    protected processGetBankAccount(response: Response): Promise<GetBankResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetBankResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GetBankResponse>(null as any);
    }

    /**
     * @return OK
     */
    updateBank(body: BankDetails): Promise<UpdateBankResponse> {
        let url_ = this.baseUrl + "/account/bank";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processUpdateBank(_response));
        });
    }

    protected processUpdateBank(response: Response): Promise<UpdateBankResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UpdateBankResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ErrorResponse.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<UpdateBankResponse>(null as any);
    }

    /**
     * @return OK
     */
    getEmployment(): Promise<GetEmploymentResponse> {
        let url_ = this.baseUrl + "/account/employment";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetEmployment(_response));
        });
    }

    protected processGetEmployment(response: Response): Promise<GetEmploymentResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetEmploymentResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GetEmploymentResponse>(null as any);
    }

    /**
     * @return OK
     */
    updateEmployment(body: EmploymentDetails): Promise<UpdateEmploymentResponse> {
        let url_ = this.baseUrl + "/account/employment";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processUpdateEmployment(_response));
        });
    }

    protected processUpdateEmployment(response: Response): Promise<UpdateEmploymentResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UpdateEmploymentResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ErrorResponse.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<UpdateEmploymentResponse>(null as any);
    }

    /**
     * @return OK
     */
    getAddress(): Promise<GetAddressResponse> {
        let url_ = this.baseUrl + "/account/address";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetAddress(_response));
        });
    }

    protected processGetAddress(response: Response): Promise<GetAddressResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetAddressResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GetAddressResponse>(null as any);
    }

    /**
     * @return OK
     */
    updateAddress(body: AddressDetails): Promise<UpdateAddressResponse> {
        let url_ = this.baseUrl + "/account/address";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processUpdateAddress(_response));
        });
    }

    protected processUpdateAddress(response: Response): Promise<UpdateAddressResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UpdateAddressResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ErrorResponse.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<UpdateAddressResponse>(null as any);
    }

    /**
     * @return OK
     */
    getContact(): Promise<GetContactResponse> {
        let url_ = this.baseUrl + "/account/contact";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetContact(_response));
        });
    }

    protected processGetContact(response: Response): Promise<GetContactResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetContactResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GetContactResponse>(null as any);
    }

    /**
     * @return OK
     */
    updateContact(body: ContactDetails): Promise<UpdateContactResponse> {
        let url_ = this.baseUrl + "/account/contact";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processUpdateContact(_response));
        });
    }

    protected processUpdateContact(response: Response): Promise<UpdateContactResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UpdateContactResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ErrorResponse.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<UpdateContactResponse>(null as any);
    }

    /**
     * @return OK
     */
    getAffordability(): Promise<GetAffordabilityResponse> {
        let url_ = this.baseUrl + "/account/affordability";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetAffordability(_response));
        });
    }

    protected processGetAffordability(response: Response): Promise<GetAffordabilityResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetAffordabilityResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GetAffordabilityResponse>(null as any);
    }

    /**
     * @return OK
     */
    updateAffordabilitylDetails(body: AffordabilityDetails): Promise<UpdateAffordabilityResponse> {
        let url_ = this.baseUrl + "/account/affordability";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processUpdateAffordabilitylDetails(_response));
        });
    }

    protected processUpdateAffordabilitylDetails(response: Response): Promise<UpdateAffordabilityResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UpdateAffordabilityResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ErrorResponse.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<UpdateAffordabilityResponse>(null as any);
    }

    /**
     * @return OK
     */
    getMigrationStatus(accountId: string): Promise<GetMigrationStatusResponse> {
        let url_ = this.baseUrl + "/account/migration/{accountId}";
        if (accountId === undefined || accountId === null)
            throw new globalThis.Error("The parameter 'accountId' must be defined.");
        url_ = url_.replace("{accountId}", encodeURIComponent("" + accountId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetMigrationStatus(_response));
        });
    }

    protected processGetMigrationStatus(response: Response): Promise<GetMigrationStatusResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetMigrationStatusResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GetMigrationStatusResponse>(null as any);
    }

    /**
     * @return OK
     */
    requestMobileVerification(body: MobileVerificationRequest): Promise<MobileVerificationResponse> {
        let url_ = this.baseUrl + "/account/customer/request-mobile-verification";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processRequestMobileVerification(_response));
        });
    }

    protected processRequestMobileVerification(response: Response): Promise<MobileVerificationResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = MobileVerificationResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ErrorResponse.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<MobileVerificationResponse>(null as any);
    }

    /**
     * @return OK
     */
    confirmMobileVerification(body: ConfirmMobileVerificationRequest): Promise<ConfirmMobileVerificationResponse> {
        let url_ = this.baseUrl + "/account/customer/confirm-mobile-verification";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processConfirmMobileVerification(_response));
        });
    }

    protected processConfirmMobileVerification(response: Response): Promise<ConfirmMobileVerificationResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ConfirmMobileVerificationResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ConfirmMobileVerificationResponse>(null as any);
    }

    /**
     * @return OK
     */
    resendMobileVerification(body: MobileVerificationRequest): Promise<MobileVerificationResponse> {
        let url_ = this.baseUrl + "/account/customer/resend-mobile-verification";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processResendMobileVerification(_response));
        });
    }

    protected processResendMobileVerification(response: Response): Promise<MobileVerificationResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = MobileVerificationResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<MobileVerificationResponse>(null as any);
    }

    /**
     * @return OK
     */
    createUpload(body: CreateUploadUrlsRequest): Promise<CreateUploadUrlsResponse> {
        let url_ = this.baseUrl + "/document/create-upload";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processCreateUpload(_response));
        });
    }

    protected processCreateUpload(response: Response): Promise<CreateUploadUrlsResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CreateUploadUrlsResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CreateUploadUrlsResponse>(null as any);
    }

    /**
     * @return OK
     */
    confirmUploads(body: ConfirmDocumentUploadsHttpRequest): Promise<ConfirmDocumentUploadsHttpResponse> {
        let url_ = this.baseUrl + "/document/confirm-upload";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processConfirmUploads(_response));
        });
    }

    protected processConfirmUploads(response: Response): Promise<ConfirmDocumentUploadsHttpResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ConfirmDocumentUploadsHttpResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ConfirmDocumentUploadsHttpResponse>(null as any);
    }

    /**
     * @return OK
     */
    getHealth(): Promise<HealthResponse> {
        let url_ = this.baseUrl + "/health";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetHealth(_response));
        });
    }

    protected processGetHealth(response: Response): Promise<HealthResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = HealthResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<HealthResponse>(null as any);
    }

    /**
     * @return OK
     */
    checkLimpEligibility(): Promise<CheckEligibilityResponse> {
        let url_ = this.baseUrl + "/legal-brilliance/customers/eligibility";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processCheckLimpEligibility(_response));
        });
    }

    protected processCheckLimpEligibility(response: Response): Promise<CheckEligibilityResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CheckEligibilityResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CheckEligibilityResponse>(null as any);
    }

    /**
     * @return OK
     */
    limpEnroll(body: EnrollRequest): Promise<EnrollCustomerResponse> {
        let url_ = this.baseUrl + "/legal-brilliance/customers/enroll";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processLimpEnroll(_response));
        });
    }

    protected processLimpEnroll(response: Response): Promise<EnrollCustomerResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = EnrollCustomerResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<EnrollCustomerResponse>(null as any);
    }

    /**
     * @return OK
     */
    limpEmailMeDetails(): Promise<EmailMeDetailsResponse> {
        let url_ = this.baseUrl + "/legal-brilliance/email-me-details";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processLimpEmailMeDetails(_response));
        });
    }

    protected processLimpEmailMeDetails(response: Response): Promise<EmailMeDetailsResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = EmailMeDetailsResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<EmailMeDetailsResponse>(null as any);
    }

    /**
     * @return OK
     */
    anonymous(): Promise<string> {
        let url_ = this.baseUrl + "/";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processAnonymous(_response));
        });
    }

    protected processAnonymous(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : _responseText;
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }
}

export class AddressDetails implements IAddressDetails {
    flat?: string | undefined;
    houseNumber?: string | undefined;
    houseName?: string | undefined;
    street?: string | undefined;
    district?: string | undefined;
    town?: string | undefined;
    country?: string | undefined;
    postCode?: string | undefined;
    suburb?: string | undefined;
    countryCode?: string | undefined;

    constructor(data?: IAddressDetails) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.flat = _data["flat"];
            this.houseNumber = _data["houseNumber"];
            this.houseName = _data["houseName"];
            this.street = _data["street"];
            this.district = _data["district"];
            this.town = _data["town"];
            this.country = _data["country"];
            this.postCode = _data["postCode"];
            this.suburb = _data["suburb"];
            this.countryCode = _data["countryCode"];
        }
    }

    static fromJS(data: any): AddressDetails {
        data = typeof data === 'object' ? data : {};
        let result = new AddressDetails();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["flat"] = this.flat;
        data["houseNumber"] = this.houseNumber;
        data["houseName"] = this.houseName;
        data["street"] = this.street;
        data["district"] = this.district;
        data["town"] = this.town;
        data["country"] = this.country;
        data["postCode"] = this.postCode;
        data["suburb"] = this.suburb;
        data["countryCode"] = this.countryCode;
        return data;
    }
}

export interface IAddressDetails {
    flat?: string | undefined;
    houseNumber?: string | undefined;
    houseName?: string | undefined;
    street?: string | undefined;
    district?: string | undefined;
    town?: string | undefined;
    country?: string | undefined;
    postCode?: string | undefined;
    suburb?: string | undefined;
    countryCode?: string | undefined;
}

export class AffordabilityDetails implements IAffordabilityDetails {
    monthlyIncome?: number;
    grossMonthlyIncome?: number;
    accomodation?: number;
    childMaintenance?: number;
    household?: number;
    transport?: number;
    otherLoans?: number;

    constructor(data?: IAffordabilityDetails) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.monthlyIncome = _data["monthlyIncome"];
            this.grossMonthlyIncome = _data["grossMonthlyIncome"];
            this.accomodation = _data["accomodation"];
            this.childMaintenance = _data["childMaintenance"];
            this.household = _data["household"];
            this.transport = _data["transport"];
            this.otherLoans = _data["otherLoans"];
        }
    }

    static fromJS(data: any): AffordabilityDetails {
        data = typeof data === 'object' ? data : {};
        let result = new AffordabilityDetails();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["monthlyIncome"] = this.monthlyIncome;
        data["grossMonthlyIncome"] = this.grossMonthlyIncome;
        data["accomodation"] = this.accomodation;
        data["childMaintenance"] = this.childMaintenance;
        data["household"] = this.household;
        data["transport"] = this.transport;
        data["otherLoans"] = this.otherLoans;
        return data;
    }
}

export interface IAffordabilityDetails {
    monthlyIncome?: number;
    grossMonthlyIncome?: number;
    accomodation?: number;
    childMaintenance?: number;
    household?: number;
    transport?: number;
    otherLoans?: number;
}

export enum AlreadyExistReasonEnum {
    Unspecified = "Unspecified",
    AccountExistsReason1 = "AccountExistsReason1",
    AccountExistsReason2 = "AccountExistsReason2",
}

export enum BankAccountType {
    Unspecified = "Unspecified",
    Savings = "Savings",
    Current = "Current",
    Cheque = "Cheque",
    Transmission = "Transmission",
}

export class BankDetails implements IBankDetails {
    bankName?: string | undefined;
    bankCode?: string | undefined;
    holderName?: string | undefined;
    accountNumber?: string | undefined;
    accountType?: string | undefined;
    openedOn?: Date | undefined;
    isVerified?: boolean;
    verifiedOn?: Date | undefined;
    bankAccountType?: BankAccountType;

    constructor(data?: IBankDetails) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.bankName = _data["bankName"];
            this.bankCode = _data["bankCode"];
            this.holderName = _data["holderName"];
            this.accountNumber = _data["accountNumber"];
            this.accountType = _data["accountType"];
            this.openedOn = _data["openedOn"] ? new Date(_data["openedOn"].toString()) : undefined as any;
            this.isVerified = _data["isVerified"];
            this.verifiedOn = _data["verifiedOn"] ? new Date(_data["verifiedOn"].toString()) : undefined as any;
            this.bankAccountType = _data["bankAccountType"];
        }
    }

    static fromJS(data: any): BankDetails {
        data = typeof data === 'object' ? data : {};
        let result = new BankDetails();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["bankName"] = this.bankName;
        data["bankCode"] = this.bankCode;
        data["holderName"] = this.holderName;
        data["accountNumber"] = this.accountNumber;
        data["accountType"] = this.accountType;
        data["openedOn"] = this.openedOn ? this.openedOn.toISOString() : undefined as any;
        data["isVerified"] = this.isVerified;
        data["verifiedOn"] = this.verifiedOn ? this.verifiedOn.toISOString() : undefined as any;
        data["bankAccountType"] = this.bankAccountType;
        return data;
    }
}

export interface IBankDetails {
    bankName?: string | undefined;
    bankCode?: string | undefined;
    holderName?: string | undefined;
    accountNumber?: string | undefined;
    accountType?: string | undefined;
    openedOn?: Date | undefined;
    isVerified?: boolean;
    verifiedOn?: Date | undefined;
    bankAccountType?: BankAccountType;
}

export class Captcha implements ICaptcha {
    token?: string | undefined;
    providerName?: string | undefined;

    constructor(data?: ICaptcha) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.token = _data["token"];
            this.providerName = _data["providerName"];
        }
    }

    static fromJS(data: any): Captcha {
        data = typeof data === 'object' ? data : {};
        let result = new Captcha();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["token"] = this.token;
        data["providerName"] = this.providerName;
        return data;
    }
}

export interface ICaptcha {
    token?: string | undefined;
    providerName?: string | undefined;
}

export class ChangePasswordRequest implements IChangePasswordRequest {
    accountId?: Uuid;
    currentPassword?: string | undefined;
    newPassword?: string | undefined;

    constructor(data?: IChangePasswordRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.accountId = _data["accountId"] ? Uuid.fromJS(_data["accountId"]) : undefined as any;
            this.currentPassword = _data["currentPassword"];
            this.newPassword = _data["newPassword"];
        }
    }

    static fromJS(data: any): ChangePasswordRequest {
        data = typeof data === 'object' ? data : {};
        let result = new ChangePasswordRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["accountId"] = this.accountId ? this.accountId.toJSON() : undefined as any;
        data["currentPassword"] = this.currentPassword;
        data["newPassword"] = this.newPassword;
        return data;
    }
}

export interface IChangePasswordRequest {
    accountId?: Uuid;
    currentPassword?: string | undefined;
    newPassword?: string | undefined;
}

export class ChangePasswordResponse implements IChangePasswordResponse {
    accountId?: string;
    status?: string | undefined;
    success?: boolean;

    constructor(data?: IChangePasswordResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.accountId = _data["accountId"];
            this.status = _data["status"];
            this.success = _data["success"];
        }
    }

    static fromJS(data: any): ChangePasswordResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ChangePasswordResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["accountId"] = this.accountId;
        data["status"] = this.status;
        data["success"] = this.success;
        return data;
    }
}

export interface IChangePasswordResponse {
    accountId?: string;
    status?: string | undefined;
    success?: boolean;
}

export class CheckEligibilityResponse implements ICheckEligibilityResponse {
    isEligible?: boolean;

    constructor(data?: ICheckEligibilityResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.isEligible = _data["isEligible"];
        }
    }

    static fromJS(data: any): CheckEligibilityResponse {
        data = typeof data === 'object' ? data : {};
        let result = new CheckEligibilityResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isEligible"] = this.isEligible;
        return data;
    }
}

export interface ICheckEligibilityResponse {
    isEligible?: boolean;
}

export class CheckPasswordVerificationOtpValidityRequest implements ICheckPasswordVerificationOtpValidityRequest {
    accountId?: string;
    pin?: string;
    captcha?: Captcha;

    constructor(data?: ICheckPasswordVerificationOtpValidityRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.accountId = _data["accountId"];
            this.pin = _data["pin"];
            this.captcha = _data["captcha"] ? Captcha.fromJS(_data["captcha"]) : undefined as any;
        }
    }

    static fromJS(data: any): CheckPasswordVerificationOtpValidityRequest {
        data = typeof data === 'object' ? data : {};
        let result = new CheckPasswordVerificationOtpValidityRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["accountId"] = this.accountId;
        data["pin"] = this.pin;
        data["captcha"] = this.captcha ? this.captcha.toJSON() : undefined as any;
        return data;
    }
}

export interface ICheckPasswordVerificationOtpValidityRequest {
    accountId?: string;
    pin?: string;
    captcha?: Captcha;
}

export class CheckPasswordVerificationOtpValidityResponse implements ICheckPasswordVerificationOtpValidityResponse {
    success?: boolean;
    status?: CheckPasswordVerificationOtpValidityResponseStatusEnums;
    captchaSuccess?: boolean;

    constructor(data?: ICheckPasswordVerificationOtpValidityResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.success = _data["success"];
            this.status = _data["status"];
            this.captchaSuccess = _data["captchaSuccess"];
        }
    }

    static fromJS(data: any): CheckPasswordVerificationOtpValidityResponse {
        data = typeof data === 'object' ? data : {};
        let result = new CheckPasswordVerificationOtpValidityResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["success"] = this.success;
        data["status"] = this.status;
        data["captchaSuccess"] = this.captchaSuccess;
        return data;
    }
}

export interface ICheckPasswordVerificationOtpValidityResponse {
    success?: boolean;
    status?: CheckPasswordVerificationOtpValidityResponseStatusEnums;
    captchaSuccess?: boolean;
}

export enum CheckPasswordVerificationOtpValidityResponseStatusEnums {
    Unspecified = "Unspecified",
    PinValid = "PinValid",
    PinExpired = "PinExpired",
}

export class CompleteForgotPasswordRequest implements ICompleteForgotPasswordRequest {
    accountId?: string;
    pin?: string;
    newPassword?: string | undefined;
    captcha?: Captcha;

    constructor(data?: ICompleteForgotPasswordRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.accountId = _data["accountId"];
            this.pin = _data["pin"];
            this.newPassword = _data["newPassword"];
            this.captcha = _data["captcha"] ? Captcha.fromJS(_data["captcha"]) : undefined as any;
        }
    }

    static fromJS(data: any): CompleteForgotPasswordRequest {
        data = typeof data === 'object' ? data : {};
        let result = new CompleteForgotPasswordRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["accountId"] = this.accountId;
        data["pin"] = this.pin;
        data["newPassword"] = this.newPassword;
        data["captcha"] = this.captcha ? this.captcha.toJSON() : undefined as any;
        return data;
    }
}

export interface ICompleteForgotPasswordRequest {
    accountId?: string;
    pin?: string;
    newPassword?: string | undefined;
    captcha?: Captcha;
}

export class CompleteForgotPasswordResponse implements ICompleteForgotPasswordResponse {
    success?: boolean;
    status?: CompleteForgotPasswordResponseStatusEnums;
    captchaSuccess?: boolean;

    constructor(data?: ICompleteForgotPasswordResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.success = _data["success"];
            this.status = _data["status"];
            this.captchaSuccess = _data["captchaSuccess"];
        }
    }

    static fromJS(data: any): CompleteForgotPasswordResponse {
        data = typeof data === 'object' ? data : {};
        let result = new CompleteForgotPasswordResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["success"] = this.success;
        data["status"] = this.status;
        data["captchaSuccess"] = this.captchaSuccess;
        return data;
    }
}

export interface ICompleteForgotPasswordResponse {
    success?: boolean;
    status?: CompleteForgotPasswordResponseStatusEnums;
    captchaSuccess?: boolean;
}

export enum CompleteForgotPasswordResponseStatusEnums {
    Unspecified = "Unspecified",
    PinConfirmed = "PinConfirmed",
    PinInvalid = "PinInvalid",
    PinExpired = "PinExpired",
    NewPasswordMatchesCurrentPassword = "NewPasswordMatchesCurrentPassword",
}

export class ConfirmDocumentUploadsHttpRequest implements IConfirmDocumentUploadsHttpRequest {
    documentIds?: string[] | undefined;

    constructor(data?: IConfirmDocumentUploadsHttpRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["documentIds"])) {
                this.documentIds = [] as any;
                for (let item of _data["documentIds"])
                    this.documentIds!.push(item);
            }
        }
    }

    static fromJS(data: any): ConfirmDocumentUploadsHttpRequest {
        data = typeof data === 'object' ? data : {};
        let result = new ConfirmDocumentUploadsHttpRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.documentIds)) {
            data["documentIds"] = [];
            for (let item of this.documentIds)
                data["documentIds"].push(item);
        }
        return data;
    }
}

export interface IConfirmDocumentUploadsHttpRequest {
    documentIds?: string[] | undefined;
}

export class ConfirmDocumentUploadsHttpResponse implements IConfirmDocumentUploadsHttpResponse {

    constructor(data?: IConfirmDocumentUploadsHttpResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
    }

    static fromJS(data: any): ConfirmDocumentUploadsHttpResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ConfirmDocumentUploadsHttpResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        return data;
    }
}

export interface IConfirmDocumentUploadsHttpResponse {
}

export class ConfirmEmailChangeRequest implements IConfirmEmailChangeRequest {
    pin?: string | undefined;
    email?: string | undefined;
    password?: string | undefined;

    constructor(data?: IConfirmEmailChangeRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.pin = _data["pin"];
            this.email = _data["email"];
            this.password = _data["password"];
        }
    }

    static fromJS(data: any): ConfirmEmailChangeRequest {
        data = typeof data === 'object' ? data : {};
        let result = new ConfirmEmailChangeRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["pin"] = this.pin;
        data["email"] = this.email;
        data["password"] = this.password;
        return data;
    }
}

export interface IConfirmEmailChangeRequest {
    pin?: string | undefined;
    email?: string | undefined;
    password?: string | undefined;
}

export class ConfirmEmailChangeResponse implements IConfirmEmailChangeResponse {
    success?: boolean;
    status?: string | undefined;

    constructor(data?: IConfirmEmailChangeResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.success = _data["success"];
            this.status = _data["status"];
        }
    }

    static fromJS(data: any): ConfirmEmailChangeResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ConfirmEmailChangeResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["success"] = this.success;
        data["status"] = this.status;
        return data;
    }
}

export interface IConfirmEmailChangeResponse {
    success?: boolean;
    status?: string | undefined;
}

export class ConfirmMobileVerificationRequest implements IConfirmMobileVerificationRequest {
    pin?: string | undefined;
    captcha?: Captcha;

    constructor(data?: IConfirmMobileVerificationRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.pin = _data["pin"];
            this.captcha = _data["captcha"] ? Captcha.fromJS(_data["captcha"]) : undefined as any;
        }
    }

    static fromJS(data: any): ConfirmMobileVerificationRequest {
        data = typeof data === 'object' ? data : {};
        let result = new ConfirmMobileVerificationRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["pin"] = this.pin;
        data["captcha"] = this.captcha ? this.captcha.toJSON() : undefined as any;
        return data;
    }
}

export interface IConfirmMobileVerificationRequest {
    pin?: string | undefined;
    captcha?: Captcha;
}

export class ConfirmMobileVerificationResponse implements IConfirmMobileVerificationResponse {
    success?: boolean;
    message?: string | undefined;
    captchaSuccess?: boolean;

    constructor(data?: IConfirmMobileVerificationResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.success = _data["success"];
            this.message = _data["message"];
            this.captchaSuccess = _data["captchaSuccess"];
        }
    }

    static fromJS(data: any): ConfirmMobileVerificationResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ConfirmMobileVerificationResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["success"] = this.success;
        data["message"] = this.message;
        data["captchaSuccess"] = this.captchaSuccess;
        return data;
    }
}

export interface IConfirmMobileVerificationResponse {
    success?: boolean;
    message?: string | undefined;
    captchaSuccess?: boolean;
}

export class ConfirmPasswordResetRequest implements IConfirmPasswordResetRequest {
    pin?: string | undefined;
    newPassword?: string | undefined;
    email?: string | undefined;
    captcha?: Captcha;

    constructor(data?: IConfirmPasswordResetRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.pin = _data["pin"];
            this.newPassword = _data["newPassword"];
            this.email = _data["email"];
            this.captcha = _data["captcha"] ? Captcha.fromJS(_data["captcha"]) : undefined as any;
        }
    }

    static fromJS(data: any): ConfirmPasswordResetRequest {
        data = typeof data === 'object' ? data : {};
        let result = new ConfirmPasswordResetRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["pin"] = this.pin;
        data["newPassword"] = this.newPassword;
        data["email"] = this.email;
        data["captcha"] = this.captcha ? this.captcha.toJSON() : undefined as any;
        return data;
    }
}

export interface IConfirmPasswordResetRequest {
    pin?: string | undefined;
    newPassword?: string | undefined;
    email?: string | undefined;
    captcha?: Captcha;
}

export class ConfirmPasswordResetResponse implements IConfirmPasswordResetResponse {
    success?: boolean;
    status?: string | undefined;
    captchaSuccess?: boolean;

    constructor(data?: IConfirmPasswordResetResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.success = _data["success"];
            this.status = _data["status"];
            this.captchaSuccess = _data["captchaSuccess"];
        }
    }

    static fromJS(data: any): ConfirmPasswordResetResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ConfirmPasswordResetResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["success"] = this.success;
        data["status"] = this.status;
        data["captchaSuccess"] = this.captchaSuccess;
        return data;
    }
}

export interface IConfirmPasswordResetResponse {
    success?: boolean;
    status?: string | undefined;
    captchaSuccess?: boolean;
}

export class ContactDetails implements IContactDetails {
    mobileNumber?: string | undefined;
    altPhone?: string | undefined;
    email?: string | undefined;
    marketing?: boolean;
    mobileNumberVerifiedOn?: Date | undefined;

    constructor(data?: IContactDetails) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.mobileNumber = _data["mobileNumber"];
            this.altPhone = _data["altPhone"];
            this.email = _data["email"];
            this.marketing = _data["marketing"];
            this.mobileNumberVerifiedOn = _data["mobileNumberVerifiedOn"] ? new Date(_data["mobileNumberVerifiedOn"].toString()) : undefined as any;
        }
    }

    static fromJS(data: any): ContactDetails {
        data = typeof data === 'object' ? data : {};
        let result = new ContactDetails();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["mobileNumber"] = this.mobileNumber;
        data["altPhone"] = this.altPhone;
        data["email"] = this.email;
        data["marketing"] = this.marketing;
        data["mobileNumberVerifiedOn"] = this.mobileNumberVerifiedOn ? this.mobileNumberVerifiedOn.toISOString() : undefined as any;
        return data;
    }
}

export interface IContactDetails {
    mobileNumber?: string | undefined;
    altPhone?: string | undefined;
    email?: string | undefined;
    marketing?: boolean;
    mobileNumberVerifiedOn?: Date | undefined;
}

export class CreateUploadUrlsRequest implements ICreateUploadUrlsRequest {
    documents?: DocumentInfo[] | undefined;

    constructor(data?: ICreateUploadUrlsRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["documents"])) {
                this.documents = [] as any;
                for (let item of _data["documents"])
                    this.documents!.push(DocumentInfo.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CreateUploadUrlsRequest {
        data = typeof data === 'object' ? data : {};
        let result = new CreateUploadUrlsRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.documents)) {
            data["documents"] = [];
            for (let item of this.documents)
                data["documents"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface ICreateUploadUrlsRequest {
    documents?: DocumentInfo[] | undefined;
}

export class CreateUploadUrlsResponse implements ICreateUploadUrlsResponse {
    documentUrls?: DocumentRef[] | undefined;

    constructor(data?: ICreateUploadUrlsResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["documentUrls"])) {
                this.documentUrls = [] as any;
                for (let item of _data["documentUrls"])
                    this.documentUrls!.push(DocumentRef.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CreateUploadUrlsResponse {
        data = typeof data === 'object' ? data : {};
        let result = new CreateUploadUrlsResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.documentUrls)) {
            data["documentUrls"] = [];
            for (let item of this.documentUrls)
                data["documentUrls"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface ICreateUploadUrlsResponse {
    documentUrls?: DocumentRef[] | undefined;
}

export class CustomerDetails implements ICustomerDetails {
    firstName?: string | undefined;
    lastName?: string | undefined;
    middleName?: string | undefined;
    homeLanguage?: string | undefined;
    homeLanguageEnum?: HomeLanguageEnum;
    gender?: string | undefined;
    genderEnum?: GenderEnum;
    dateOfBirth?: Date;
    maritalStatus?: string | undefined;
    maritalStatusEnum?: MaritalStatusEnum;
    marriedInCommunityProperty?: boolean;
    dependents?: number;
    idNumber?: string | undefined;
    homeStatus?: string | undefined;
    easyPayNumber?: string | undefined;
    isPip?: boolean;
    homeStatusEnum?: HomeStatusEnum;

    constructor(data?: ICustomerDetails) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.middleName = _data["middleName"];
            this.homeLanguage = _data["homeLanguage"];
            this.homeLanguageEnum = _data["homeLanguageEnum"];
            this.gender = _data["gender"];
            this.genderEnum = _data["genderEnum"];
            this.dateOfBirth = _data["dateOfBirth"] ? new Date(_data["dateOfBirth"].toString()) : undefined as any;
            this.maritalStatus = _data["maritalStatus"];
            this.maritalStatusEnum = _data["maritalStatusEnum"];
            this.marriedInCommunityProperty = _data["marriedInCommunityProperty"];
            this.dependents = _data["dependents"];
            this.idNumber = _data["idNumber"];
            this.homeStatus = _data["homeStatus"];
            this.easyPayNumber = _data["easyPayNumber"];
            this.isPip = _data["isPip"];
            this.homeStatusEnum = _data["homeStatusEnum"];
        }
    }

    static fromJS(data: any): CustomerDetails {
        data = typeof data === 'object' ? data : {};
        let result = new CustomerDetails();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["middleName"] = this.middleName;
        data["homeLanguage"] = this.homeLanguage;
        data["homeLanguageEnum"] = this.homeLanguageEnum;
        data["gender"] = this.gender;
        data["genderEnum"] = this.genderEnum;
        data["dateOfBirth"] = this.dateOfBirth ? this.dateOfBirth.toISOString() : undefined as any;
        data["maritalStatus"] = this.maritalStatus;
        data["maritalStatusEnum"] = this.maritalStatusEnum;
        data["marriedInCommunityProperty"] = this.marriedInCommunityProperty;
        data["dependents"] = this.dependents;
        data["idNumber"] = this.idNumber;
        data["homeStatus"] = this.homeStatus;
        data["easyPayNumber"] = this.easyPayNumber;
        data["isPip"] = this.isPip;
        data["homeStatusEnum"] = this.homeStatusEnum;
        return data;
    }
}

export interface ICustomerDetails {
    firstName?: string | undefined;
    lastName?: string | undefined;
    middleName?: string | undefined;
    homeLanguage?: string | undefined;
    homeLanguageEnum?: HomeLanguageEnum;
    gender?: string | undefined;
    genderEnum?: GenderEnum;
    dateOfBirth?: Date;
    maritalStatus?: string | undefined;
    maritalStatusEnum?: MaritalStatusEnum;
    marriedInCommunityProperty?: boolean;
    dependents?: number;
    idNumber?: string | undefined;
    homeStatus?: string | undefined;
    easyPayNumber?: string | undefined;
    isPip?: boolean;
    homeStatusEnum?: HomeStatusEnum;
}

export class DocumentInfo implements IDocumentInfo {
    documentName?: string | undefined;
    fileName?: string | undefined;
    documentId?: string | undefined;
    documentDate?: Date | undefined;

    constructor(data?: IDocumentInfo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.documentName = _data["documentName"];
            this.fileName = _data["fileName"];
            this.documentId = _data["documentId"];
            this.documentDate = _data["documentDate"] ? new Date(_data["documentDate"].toString()) : undefined as any;
        }
    }

    static fromJS(data: any): DocumentInfo {
        data = typeof data === 'object' ? data : {};
        let result = new DocumentInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["documentName"] = this.documentName;
        data["fileName"] = this.fileName;
        data["documentId"] = this.documentId;
        data["documentDate"] = this.documentDate ? this.documentDate.toISOString() : undefined as any;
        return data;
    }
}

export interface IDocumentInfo {
    documentName?: string | undefined;
    fileName?: string | undefined;
    documentId?: string | undefined;
    documentDate?: Date | undefined;
}

export class DocumentRef implements IDocumentRef {
    documentId?: string;
    url?: string | undefined;
    contentType?: string | undefined;

    constructor(data?: IDocumentRef) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.documentId = _data["documentId"];
            this.url = _data["url"];
            this.contentType = _data["contentType"];
        }
    }

    static fromJS(data: any): DocumentRef {
        data = typeof data === 'object' ? data : {};
        let result = new DocumentRef();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["documentId"] = this.documentId;
        data["url"] = this.url;
        data["contentType"] = this.contentType;
        return data;
    }
}

export interface IDocumentRef {
    documentId?: string;
    url?: string | undefined;
    contentType?: string | undefined;
}

export class EmailMeDetailsResponse implements IEmailMeDetailsResponse {

    constructor(data?: IEmailMeDetailsResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
    }

    static fromJS(data: any): EmailMeDetailsResponse {
        data = typeof data === 'object' ? data : {};
        let result = new EmailMeDetailsResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        return data;
    }
}

export interface IEmailMeDetailsResponse {
}

export class EmploymentDetails implements IEmploymentDetails {
    employerName?: string | undefined;
    position?: string | undefined;
    positionEnum?: PositionEnum;
    industry?: string | undefined;
    industryEnum?: EmploymentIndustryEnum;
    netIncome?: number;
    incomeFrequency?: number;
    incomeFrequencyEnum?: IncomeFrequencyEnum;
    salaryDay?: number;
    employmentStatus?: string | undefined;
    employmentStatusEnum?: EmploymentStatusEnum;
    employedOn?: Date | undefined;
    nextPayDate?: Date;
    allowedToUpdate?: boolean;
    grossIncome?: number;
    workPhone?: string | undefined;

    constructor(data?: IEmploymentDetails) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.employerName = _data["employerName"];
            this.position = _data["position"];
            this.positionEnum = _data["positionEnum"];
            this.industry = _data["industry"];
            this.industryEnum = _data["industryEnum"];
            this.netIncome = _data["netIncome"];
            this.incomeFrequency = _data["incomeFrequency"];
            this.incomeFrequencyEnum = _data["incomeFrequencyEnum"];
            this.salaryDay = _data["salaryDay"];
            this.employmentStatus = _data["employmentStatus"];
            this.employmentStatusEnum = _data["employmentStatusEnum"];
            this.employedOn = _data["employedOn"] ? new Date(_data["employedOn"].toString()) : undefined as any;
            this.nextPayDate = _data["nextPayDate"] ? new Date(_data["nextPayDate"].toString()) : undefined as any;
            this.allowedToUpdate = _data["allowedToUpdate"];
            this.grossIncome = _data["grossIncome"];
            this.workPhone = _data["workPhone"];
        }
    }

    static fromJS(data: any): EmploymentDetails {
        data = typeof data === 'object' ? data : {};
        let result = new EmploymentDetails();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["employerName"] = this.employerName;
        data["position"] = this.position;
        data["positionEnum"] = this.positionEnum;
        data["industry"] = this.industry;
        data["industryEnum"] = this.industryEnum;
        data["netIncome"] = this.netIncome;
        data["incomeFrequency"] = this.incomeFrequency;
        data["incomeFrequencyEnum"] = this.incomeFrequencyEnum;
        data["salaryDay"] = this.salaryDay;
        data["employmentStatus"] = this.employmentStatus;
        data["employmentStatusEnum"] = this.employmentStatusEnum;
        data["employedOn"] = this.employedOn ? this.employedOn.toISOString() : undefined as any;
        data["nextPayDate"] = this.nextPayDate ? this.nextPayDate.toISOString() : undefined as any;
        data["allowedToUpdate"] = this.allowedToUpdate;
        data["grossIncome"] = this.grossIncome;
        data["workPhone"] = this.workPhone;
        return data;
    }
}

export interface IEmploymentDetails {
    employerName?: string | undefined;
    position?: string | undefined;
    positionEnum?: PositionEnum;
    industry?: string | undefined;
    industryEnum?: EmploymentIndustryEnum;
    netIncome?: number;
    incomeFrequency?: number;
    incomeFrequencyEnum?: IncomeFrequencyEnum;
    salaryDay?: number;
    employmentStatus?: string | undefined;
    employmentStatusEnum?: EmploymentStatusEnum;
    employedOn?: Date | undefined;
    nextPayDate?: Date;
    allowedToUpdate?: boolean;
    grossIncome?: number;
    workPhone?: string | undefined;
}

export enum EmploymentIndustryEnum {
    Unspecified = "Unspecified",
    Accountancy = "Accountancy",
    AdvertisingAndMedia = "AdvertisingAndMedia",
    BusinessConsultancy = "BusinessConsultancy",
    CallCentreOperations = "CallCentreOperations",
    Cleaning = "Cleaning",
    ComputerServices = "ComputerServices",
    Construction = "Construction",
    Education = "Education",
    Electricity = "Electricity",
    Finance = "Finance",
    Health = "Health",
    HotelsRestaurants = "HotelsRestaurants",
    Insurance = "Insurance",
    LegalServices = "LegalServices",
    LeisureCulturalTravelAndTourism = "LeisureCulturalTravelAndTourism",
    Manufacturing = "Manufacturing",
    Mining = "Mining",
    PublicAdministration = "PublicAdministration",
    Publishing = "Publishing",
    Property = "Property",
    ResearchDevelopment = "ResearchDevelopment",
    Retail = "Retail",
    TelecommunicationsInternetAndIT = "TelecommunicationsInternetAndIT",
    TransportationAndLogistics = "TransportationAndLogistics",
}

export enum EmploymentStatusEnum {
    Unspecified = "Unspecified",
    EmployedFullTime = "EmployedFullTime",
    EmployedPartTime = "EmployedPartTime",
    EmployedTemporary = "EmployedTemporary",
    SelfEmployed = "SelfEmployed",
    Student = "Student",
    HomeMaker = "HomeMaker",
    Retired = "Retired",
    Unemployed = "Unemployed",
    OnBenefits = "OnBenefits",
    ArmedForces = "ArmedForces",
}

export class EnrollCustomerResponse implements IEnrollCustomerResponse {
    statusEnum?: EnrollmentStatusEnum;

    constructor(data?: IEnrollCustomerResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.statusEnum = _data["statusEnum"];
        }
    }

    static fromJS(data: any): EnrollCustomerResponse {
        data = typeof data === 'object' ? data : {};
        let result = new EnrollCustomerResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["statusEnum"] = this.statusEnum;
        return data;
    }
}

export interface IEnrollCustomerResponse {
    statusEnum?: EnrollmentStatusEnum;
}

export class EnrollRequest implements IEnrollRequest {
    salaryDay?: number;

    constructor(data?: IEnrollRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.salaryDay = _data["salaryDay"];
        }
    }

    static fromJS(data: any): EnrollRequest {
        data = typeof data === 'object' ? data : {};
        let result = new EnrollRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["salaryDay"] = this.salaryDay;
        return data;
    }
}

export interface IEnrollRequest {
    salaryDay?: number;
}

export enum EnrollmentStatusEnum {
    Unspecified = "Unspecified",
    ValidationError = "ValidationError",
    CustomerAlreadyActive = "CustomerAlreadyActive",
    Success = "Success",
    MissingDetails = "MissingDetails",
    InvalidSalaryDay = "InvalidSalaryDay",
}

export class ErrorResponse implements IErrorResponse {
    message?: string | undefined;
    errorCode?: number;

    constructor(data?: IErrorResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.message = _data["message"];
            this.errorCode = _data["errorCode"];
        }
    }

    static fromJS(data: any): ErrorResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ErrorResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["message"] = this.message;
        data["errorCode"] = this.errorCode;
        return data;
    }
}

export interface IErrorResponse {
    message?: string | undefined;
    errorCode?: number;
}

export enum GenderEnum {
    Unspecified = "Unspecified",
    Male = "Male",
    Female = "Female",
}

export class GenerateChangeEmailPinRequest implements IGenerateChangeEmailPinRequest {
    email?: string | undefined;

    constructor(data?: IGenerateChangeEmailPinRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.email = _data["email"];
        }
    }

    static fromJS(data: any): GenerateChangeEmailPinRequest {
        data = typeof data === 'object' ? data : {};
        let result = new GenerateChangeEmailPinRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["email"] = this.email;
        return data;
    }
}

export interface IGenerateChangeEmailPinRequest {
    email?: string | undefined;
}

export class GenerateChangeEmailPinResponse implements IGenerateChangeEmailPinResponse {
    success?: boolean;
    status?: string | undefined;

    constructor(data?: IGenerateChangeEmailPinResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.success = _data["success"];
            this.status = _data["status"];
        }
    }

    static fromJS(data: any): GenerateChangeEmailPinResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GenerateChangeEmailPinResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["success"] = this.success;
        data["status"] = this.status;
        return data;
    }
}

export interface IGenerateChangeEmailPinResponse {
    success?: boolean;
    status?: string | undefined;
}

export class GenerateForgotPasswordPinRequest implements IGenerateForgotPasswordPinRequest {
    idNumber?: string | undefined;
    captcha?: Captcha;

    constructor(data?: IGenerateForgotPasswordPinRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.idNumber = _data["idNumber"];
            this.captcha = _data["captcha"] ? Captcha.fromJS(_data["captcha"]) : undefined as any;
        }
    }

    static fromJS(data: any): GenerateForgotPasswordPinRequest {
        data = typeof data === 'object' ? data : {};
        let result = new GenerateForgotPasswordPinRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["idNumber"] = this.idNumber;
        data["captcha"] = this.captcha ? this.captcha.toJSON() : undefined as any;
        return data;
    }
}

export interface IGenerateForgotPasswordPinRequest {
    idNumber?: string | undefined;
    captcha?: Captcha;
}

export class GenerateForgotPasswordPinResponse implements IGenerateForgotPasswordPinResponse {
    captchaSuccess?: boolean;

    constructor(data?: IGenerateForgotPasswordPinResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.captchaSuccess = _data["captchaSuccess"];
        }
    }

    static fromJS(data: any): GenerateForgotPasswordPinResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GenerateForgotPasswordPinResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["captchaSuccess"] = this.captchaSuccess;
        return data;
    }
}

export interface IGenerateForgotPasswordPinResponse {
    captchaSuccess?: boolean;
}

export class GenerateResetPasswordPinRequest implements IGenerateResetPasswordPinRequest {
    email?: string | undefined;
    captcha?: Captcha;

    constructor(data?: IGenerateResetPasswordPinRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.email = _data["email"];
            this.captcha = _data["captcha"] ? Captcha.fromJS(_data["captcha"]) : undefined as any;
        }
    }

    static fromJS(data: any): GenerateResetPasswordPinRequest {
        data = typeof data === 'object' ? data : {};
        let result = new GenerateResetPasswordPinRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["email"] = this.email;
        data["captcha"] = this.captcha ? this.captcha.toJSON() : undefined as any;
        return data;
    }
}

export interface IGenerateResetPasswordPinRequest {
    email?: string | undefined;
    captcha?: Captcha;
}

export class GenerateResetPasswordPinResponse implements IGenerateResetPasswordPinResponse {
    success?: boolean;
    status?: string | undefined;
    captchaSuccess?: boolean;

    constructor(data?: IGenerateResetPasswordPinResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.success = _data["success"];
            this.status = _data["status"];
            this.captchaSuccess = _data["captchaSuccess"];
        }
    }

    static fromJS(data: any): GenerateResetPasswordPinResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GenerateResetPasswordPinResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["success"] = this.success;
        data["status"] = this.status;
        data["captchaSuccess"] = this.captchaSuccess;
        return data;
    }
}

export interface IGenerateResetPasswordPinResponse {
    success?: boolean;
    status?: string | undefined;
    captchaSuccess?: boolean;
}

export class GetAddressResponse implements IGetAddressResponse {
    address?: AddressDetails;
    addressExists?: boolean;

    constructor(data?: IGetAddressResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.address = _data["address"] ? AddressDetails.fromJS(_data["address"]) : undefined as any;
            this.addressExists = _data["addressExists"];
        }
    }

    static fromJS(data: any): GetAddressResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetAddressResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["address"] = this.address ? this.address.toJSON() : undefined as any;
        data["addressExists"] = this.addressExists;
        return data;
    }
}

export interface IGetAddressResponse {
    address?: AddressDetails;
    addressExists?: boolean;
}

export class GetAffordabilityResponse implements IGetAffordabilityResponse {
    affordability?: AffordabilityDetails;
    affordabilityExists?: boolean;

    constructor(data?: IGetAffordabilityResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.affordability = _data["affordability"] ? AffordabilityDetails.fromJS(_data["affordability"]) : undefined as any;
            this.affordabilityExists = _data["affordabilityExists"];
        }
    }

    static fromJS(data: any): GetAffordabilityResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetAffordabilityResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["affordability"] = this.affordability ? this.affordability.toJSON() : undefined as any;
        data["affordabilityExists"] = this.affordabilityExists;
        return data;
    }
}

export interface IGetAffordabilityResponse {
    affordability?: AffordabilityDetails;
    affordabilityExists?: boolean;
}

export class GetBankResponse implements IGetBankResponse {
    bank?: BankDetails;
    bankAccountExists?: boolean;

    constructor(data?: IGetBankResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.bank = _data["bank"] ? BankDetails.fromJS(_data["bank"]) : undefined as any;
            this.bankAccountExists = _data["bankAccountExists"];
        }
    }

    static fromJS(data: any): GetBankResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetBankResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["bank"] = this.bank ? this.bank.toJSON() : undefined as any;
        data["bankAccountExists"] = this.bankAccountExists;
        return data;
    }
}

export interface IGetBankResponse {
    bank?: BankDetails;
    bankAccountExists?: boolean;
}

export class GetContactResponse implements IGetContactResponse {
    contact?: ContactDetails;
    contactExists?: boolean;

    constructor(data?: IGetContactResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.contact = _data["contact"] ? ContactDetails.fromJS(_data["contact"]) : undefined as any;
            this.contactExists = _data["contactExists"];
        }
    }

    static fromJS(data: any): GetContactResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetContactResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["contact"] = this.contact ? this.contact.toJSON() : undefined as any;
        data["contactExists"] = this.contactExists;
        return data;
    }
}

export interface IGetContactResponse {
    contact?: ContactDetails;
    contactExists?: boolean;
}

export class GetCustomerResponse implements IGetCustomerResponse {
    customer?: CustomerDetails;
    customerExists?: boolean;

    constructor(data?: IGetCustomerResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.customer = _data["customer"] ? CustomerDetails.fromJS(_data["customer"]) : undefined as any;
            this.customerExists = _data["customerExists"];
        }
    }

    static fromJS(data: any): GetCustomerResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetCustomerResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["customer"] = this.customer ? this.customer.toJSON() : undefined as any;
        data["customerExists"] = this.customerExists;
        return data;
    }
}

export interface IGetCustomerResponse {
    customer?: CustomerDetails;
    customerExists?: boolean;
}

export class GetEmploymentResponse implements IGetEmploymentResponse {
    employment?: EmploymentDetails;
    employmentExists?: boolean;

    constructor(data?: IGetEmploymentResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.employment = _data["employment"] ? EmploymentDetails.fromJS(_data["employment"]) : undefined as any;
            this.employmentExists = _data["employmentExists"];
        }
    }

    static fromJS(data: any): GetEmploymentResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetEmploymentResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["employment"] = this.employment ? this.employment.toJSON() : undefined as any;
        data["employmentExists"] = this.employmentExists;
        return data;
    }
}

export interface IGetEmploymentResponse {
    employment?: EmploymentDetails;
    employmentExists?: boolean;
}

export class GetMigrationStatusResponse implements IGetMigrationStatusResponse {
    state?: string | undefined;

    constructor(data?: IGetMigrationStatusResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.state = _data["state"];
        }
    }

    static fromJS(data: any): GetMigrationStatusResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetMigrationStatusResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["state"] = this.state;
        return data;
    }
}

export interface IGetMigrationStatusResponse {
    state?: string | undefined;
}

export class GetPersonalDetailsResponse implements IGetPersonalDetailsResponse {
    personalDetails?: PersonalDetails;
    accountExists?: boolean;
    customerExists?: boolean;
    addressExists?: boolean;
    contactExists?: boolean;
    employmentExists?: boolean;
    bankExists?: boolean;
    affordabilityExists?: boolean;
    personalDetailsIsComplete?: boolean;

    constructor(data?: IGetPersonalDetailsResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.personalDetails = _data["personalDetails"] ? PersonalDetails.fromJS(_data["personalDetails"]) : undefined as any;
            this.accountExists = _data["accountExists"];
            this.customerExists = _data["customerExists"];
            this.addressExists = _data["addressExists"];
            this.contactExists = _data["contactExists"];
            this.employmentExists = _data["employmentExists"];
            this.bankExists = _data["bankExists"];
            this.affordabilityExists = _data["affordabilityExists"];
            this.personalDetailsIsComplete = _data["personalDetailsIsComplete"];
        }
    }

    static fromJS(data: any): GetPersonalDetailsResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetPersonalDetailsResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["personalDetails"] = this.personalDetails ? this.personalDetails.toJSON() : undefined as any;
        data["accountExists"] = this.accountExists;
        data["customerExists"] = this.customerExists;
        data["addressExists"] = this.addressExists;
        data["contactExists"] = this.contactExists;
        data["employmentExists"] = this.employmentExists;
        data["bankExists"] = this.bankExists;
        data["affordabilityExists"] = this.affordabilityExists;
        data["personalDetailsIsComplete"] = this.personalDetailsIsComplete;
        return data;
    }
}

export interface IGetPersonalDetailsResponse {
    personalDetails?: PersonalDetails;
    accountExists?: boolean;
    customerExists?: boolean;
    addressExists?: boolean;
    contactExists?: boolean;
    employmentExists?: boolean;
    bankExists?: boolean;
    affordabilityExists?: boolean;
    personalDetailsIsComplete?: boolean;
}

export class HealthResponse implements IHealthResponse {
    healthy?: boolean;

    constructor(data?: IHealthResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.healthy = _data["healthy"];
        }
    }

    static fromJS(data: any): HealthResponse {
        data = typeof data === 'object' ? data : {};
        let result = new HealthResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["healthy"] = this.healthy;
        return data;
    }
}

export interface IHealthResponse {
    healthy?: boolean;
}

export enum HomeLanguageEnum {
    Unspecified = "Unspecified",
    English = "English",
    Afrikaans = "Afrikaans",
    IsIndebele = "IsIndebele",
    IsIxhosa = "IsIxhosa",
    IsIzulu = "IsIzulu",
    NorthernSotho = "NorthernSotho",
    Sesotho = "Sesotho",
    Setswana = "Setswana",
    SiSwati = "SiSwati",
    Tshivenda = "Tshivenda",
    XitSonga = "XitSonga",
    Other = "Other",
}

export enum HomeStatusEnum {
    Unspecified = "Unspecified",
    OwnerOccupier = "OwnerOccupier",
    LivingWithParents = "LivingWithParents",
    TenantFurnished = "TenantFurnished",
    TenantUnfurnished = "TenantUnfurnished",
    CouncilTenant = "CouncilTenant",
    Tenant = "Tenant",
    JointOwner = "JointOwner",
    OtherNotDefined = "OtherNotDefined",
    Other = "Other",
}

export enum IncomeFrequencyEnum {
    Unspecified = "Unspecified",
    Monthly = "Monthly",
    TwiceMonthly = "TwiceMonthly",
    Weekly = "Weekly",
    LastDayOfMonth = "LastDayOfMonth",
    LastFridayOfMonth = "LastFridayOfMonth",
    BiWeekly = "BiWeekly",
    TwiceMonthly15ThAnd30Th = "TwiceMonthly15ThAnd30Th",
}

export class LoginRequest implements ILoginRequest {
    email?: string | undefined;
    userName?: string | undefined;
    password?: string | undefined;
    captcha?: Captcha;

    constructor(data?: ILoginRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.email = _data["email"];
            this.userName = _data["userName"];
            this.password = _data["password"];
            this.captcha = _data["captcha"] ? Captcha.fromJS(_data["captcha"]) : undefined as any;
        }
    }

    static fromJS(data: any): LoginRequest {
        data = typeof data === 'object' ? data : {};
        let result = new LoginRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["email"] = this.email;
        data["userName"] = this.userName;
        data["password"] = this.password;
        data["captcha"] = this.captcha ? this.captcha.toJSON() : undefined as any;
        return data;
    }
}

export interface ILoginRequest {
    email?: string | undefined;
    userName?: string | undefined;
    password?: string | undefined;
    captcha?: Captcha;
}

export class LoginResponse implements ILoginResponse {
    success?: boolean;
    token?: string | undefined;
    tokenExpiry?: string | undefined;
    status?: LoginResponseStatusEnums;
    accountId?: string | undefined;
    loginId?: string | undefined;
    captchaSuccess?: boolean;

    constructor(data?: ILoginResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.success = _data["success"];
            this.token = _data["token"];
            this.tokenExpiry = _data["tokenExpiry"];
            this.status = _data["status"];
            this.accountId = _data["accountId"];
            this.loginId = _data["loginId"];
            this.captchaSuccess = _data["captchaSuccess"];
        }
    }

    static fromJS(data: any): LoginResponse {
        data = typeof data === 'object' ? data : {};
        let result = new LoginResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["success"] = this.success;
        data["token"] = this.token;
        data["tokenExpiry"] = this.tokenExpiry;
        data["status"] = this.status;
        data["accountId"] = this.accountId;
        data["loginId"] = this.loginId;
        data["captchaSuccess"] = this.captchaSuccess;
        return data;
    }
}

export interface ILoginResponse {
    success?: boolean;
    token?: string | undefined;
    tokenExpiry?: string | undefined;
    status?: LoginResponseStatusEnums;
    accountId?: string | undefined;
    loginId?: string | undefined;
    captchaSuccess?: boolean;
}

export enum LoginResponseStatusEnums {
    Unspecified = "Unspecified",
    InvalidCredentials = "InvalidCredentials",
    LoginLocked = "LoginLocked",
    MigrationPending = "MigrationPending",
    Authenticated = "Authenticated",
}

export class LoginWithOtpRequest implements ILoginWithOtpRequest {
    accountId?: Uuid;
    pin?: string | undefined;
    ipAddress?: string | undefined;

    constructor(data?: ILoginWithOtpRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.accountId = _data["accountId"] ? Uuid.fromJS(_data["accountId"]) : undefined as any;
            this.pin = _data["pin"];
            this.ipAddress = _data["ipAddress"];
        }
    }

    static fromJS(data: any): LoginWithOtpRequest {
        data = typeof data === 'object' ? data : {};
        let result = new LoginWithOtpRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["accountId"] = this.accountId ? this.accountId.toJSON() : undefined as any;
        data["pin"] = this.pin;
        data["ipAddress"] = this.ipAddress;
        return data;
    }
}

export interface ILoginWithOtpRequest {
    accountId?: Uuid;
    pin?: string | undefined;
    ipAddress?: string | undefined;
}

export class LoginWithOtpResponse implements ILoginWithOtpResponse {
    success?: boolean;
    token?: string | undefined;
    tokenExpiry?: string | undefined;
    status?: LoginWithOtpResponseStatusEnums;
    accountId?: string | undefined;
    loginId?: string | undefined;

    constructor(data?: ILoginWithOtpResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.success = _data["success"];
            this.token = _data["token"];
            this.tokenExpiry = _data["tokenExpiry"];
            this.status = _data["status"];
            this.accountId = _data["accountId"];
            this.loginId = _data["loginId"];
        }
    }

    static fromJS(data: any): LoginWithOtpResponse {
        data = typeof data === 'object' ? data : {};
        let result = new LoginWithOtpResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["success"] = this.success;
        data["token"] = this.token;
        data["tokenExpiry"] = this.tokenExpiry;
        data["status"] = this.status;
        data["accountId"] = this.accountId;
        data["loginId"] = this.loginId;
        return data;
    }
}

export interface ILoginWithOtpResponse {
    success?: boolean;
    token?: string | undefined;
    tokenExpiry?: string | undefined;
    status?: LoginWithOtpResponseStatusEnums;
    accountId?: string | undefined;
    loginId?: string | undefined;
}

export enum LoginWithOtpResponseStatusEnums {
    Unspecified = "Unspecified",
    LoginLocked = "LoginLocked",
    MobileVerificationFailed = "MobileVerificationFailed",
    Authenticated = "Authenticated",
}

export enum MaritalStatusEnum {
    Unspecified = "Unspecified",
    MarriedOutOfCommunityOfProperty = "MarriedOutOfCommunityOfProperty",
    MarriedInCommunityOfProperty = "MarriedInCommunityOfProperty",
    Single = "Single",
    Divorced = "Divorced",
    Widowed = "Widowed",
    LivingTogether = "LivingTogether",
    Separated = "Separated",
    Other = "Other",
}

export class MobileVerificationRequest implements IMobileVerificationRequest {
    mobileNumber?: string | undefined;
    captcha?: Captcha;

    constructor(data?: IMobileVerificationRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.mobileNumber = _data["mobileNumber"];
            this.captcha = _data["captcha"] ? Captcha.fromJS(_data["captcha"]) : undefined as any;
        }
    }

    static fromJS(data: any): MobileVerificationRequest {
        data = typeof data === 'object' ? data : {};
        let result = new MobileVerificationRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["mobileNumber"] = this.mobileNumber;
        data["captcha"] = this.captcha ? this.captcha.toJSON() : undefined as any;
        return data;
    }
}

export interface IMobileVerificationRequest {
    mobileNumber?: string | undefined;
    captcha?: Captcha;
}

export class MobileVerificationResponse implements IMobileVerificationResponse {
    success?: boolean;
    captchaSuccess?: boolean;

    constructor(data?: IMobileVerificationResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.success = _data["success"];
            this.captchaSuccess = _data["captchaSuccess"];
        }
    }

    static fromJS(data: any): MobileVerificationResponse {
        data = typeof data === 'object' ? data : {};
        let result = new MobileVerificationResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["success"] = this.success;
        data["captchaSuccess"] = this.captchaSuccess;
        return data;
    }
}

export interface IMobileVerificationResponse {
    success?: boolean;
    captchaSuccess?: boolean;
}

export class PersonalDetails implements IPersonalDetails {
    customer?: CustomerDetails;
    bank?: BankDetails;
    employment?: EmploymentDetails;
    address?: AddressDetails;
    contact?: ContactDetails;
    affordability?: AffordabilityDetails;

    constructor(data?: IPersonalDetails) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.customer = _data["customer"] ? CustomerDetails.fromJS(_data["customer"]) : undefined as any;
            this.bank = _data["bank"] ? BankDetails.fromJS(_data["bank"]) : undefined as any;
            this.employment = _data["employment"] ? EmploymentDetails.fromJS(_data["employment"]) : undefined as any;
            this.address = _data["address"] ? AddressDetails.fromJS(_data["address"]) : undefined as any;
            this.contact = _data["contact"] ? ContactDetails.fromJS(_data["contact"]) : undefined as any;
            this.affordability = _data["affordability"] ? AffordabilityDetails.fromJS(_data["affordability"]) : undefined as any;
        }
    }

    static fromJS(data: any): PersonalDetails {
        data = typeof data === 'object' ? data : {};
        let result = new PersonalDetails();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["customer"] = this.customer ? this.customer.toJSON() : undefined as any;
        data["bank"] = this.bank ? this.bank.toJSON() : undefined as any;
        data["employment"] = this.employment ? this.employment.toJSON() : undefined as any;
        data["address"] = this.address ? this.address.toJSON() : undefined as any;
        data["contact"] = this.contact ? this.contact.toJSON() : undefined as any;
        data["affordability"] = this.affordability ? this.affordability.toJSON() : undefined as any;
        return data;
    }
}

export interface IPersonalDetails {
    customer?: CustomerDetails;
    bank?: BankDetails;
    employment?: EmploymentDetails;
    address?: AddressDetails;
    contact?: ContactDetails;
    affordability?: AffordabilityDetails;
}

export enum PositionEnum {
    Unspecified = "Unspecified",
    ActorMusicianArtistWriterJournalist = "ActorMusicianArtistWriterJournalist",
    Administration = "Administration",
    BusDriver = "BusDriver",
    BusinessDevelopment = "BusinessDevelopment",
    BusinessOwner = "BusinessOwner",
    Consultancy = "Consultancy",
    Doctor = "Doctor",
    Engineering = "Engineering",
    Marketing = "Marketing",
    CabDriver = "CabDriver",
    Musician = "Musician",
    Nurse = "Nurse",
    Other = "Other",
    Sales = "Sales",
    SeniorManagementDirector = "SeniorManagementDirector",
    Services = "Services",
    Teacher = "Teacher",
    TruckDriver = "TruckDriver",
    Firefighter = "Firefighter",
    Management = "Management",
    TaxiDriver = "TaxiDriver",
    Mining = "Mining",
}

export class RefreshTokenResponse implements IRefreshTokenResponse {
    token?: string | undefined;
    tokenExpiry?: string | undefined;
    status?: string | undefined;
    success?: boolean;

    constructor(data?: IRefreshTokenResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.token = _data["token"];
            this.tokenExpiry = _data["tokenExpiry"];
            this.status = _data["status"];
            this.success = _data["success"];
        }
    }

    static fromJS(data: any): RefreshTokenResponse {
        data = typeof data === 'object' ? data : {};
        let result = new RefreshTokenResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["token"] = this.token;
        data["tokenExpiry"] = this.tokenExpiry;
        data["status"] = this.status;
        data["success"] = this.success;
        return data;
    }
}

export interface IRefreshTokenResponse {
    token?: string | undefined;
    tokenExpiry?: string | undefined;
    status?: string | undefined;
    success?: boolean;
}

export class RegisterCustomerRequest implements IRegisterCustomerRequest {
    emailAddress?: string | undefined;
    password?: string | undefined;
    idNumber?: string | undefined;
    accountId?: string | undefined;
    captcha?: Captcha;

    constructor(data?: IRegisterCustomerRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.emailAddress = _data["emailAddress"];
            this.password = _data["password"];
            this.idNumber = _data["idNumber"];
            this.accountId = _data["accountId"];
            this.captcha = _data["captcha"] ? Captcha.fromJS(_data["captcha"]) : undefined as any;
        }
    }

    static fromJS(data: any): RegisterCustomerRequest {
        data = typeof data === 'object' ? data : {};
        let result = new RegisterCustomerRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["emailAddress"] = this.emailAddress;
        data["password"] = this.password;
        data["idNumber"] = this.idNumber;
        data["accountId"] = this.accountId;
        data["captcha"] = this.captcha ? this.captcha.toJSON() : undefined as any;
        return data;
    }
}

export interface IRegisterCustomerRequest {
    emailAddress?: string | undefined;
    password?: string | undefined;
    idNumber?: string | undefined;
    accountId?: string | undefined;
    captcha?: Captcha;
}

export class RegisterCustomerResponse implements IRegisterCustomerResponse {
    success?: boolean;
    alreadyExists?: boolean;
    alreadyExistReason?: AlreadyExistReasonEnum;
    token?: string | undefined;
    accountId?: string | undefined;
    tokenExpiry?: string | undefined;
    captchaSuccess?: boolean;

    constructor(data?: IRegisterCustomerResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.success = _data["success"];
            this.alreadyExists = _data["alreadyExists"];
            this.alreadyExistReason = _data["alreadyExistReason"];
            this.token = _data["token"];
            this.accountId = _data["accountId"];
            this.tokenExpiry = _data["tokenExpiry"];
            this.captchaSuccess = _data["captchaSuccess"];
        }
    }

    static fromJS(data: any): RegisterCustomerResponse {
        data = typeof data === 'object' ? data : {};
        let result = new RegisterCustomerResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["success"] = this.success;
        data["alreadyExists"] = this.alreadyExists;
        data["alreadyExistReason"] = this.alreadyExistReason;
        data["token"] = this.token;
        data["accountId"] = this.accountId;
        data["tokenExpiry"] = this.tokenExpiry;
        data["captchaSuccess"] = this.captchaSuccess;
        return data;
    }
}

export interface IRegisterCustomerResponse {
    success?: boolean;
    alreadyExists?: boolean;
    alreadyExistReason?: AlreadyExistReasonEnum;
    token?: string | undefined;
    accountId?: string | undefined;
    tokenExpiry?: string | undefined;
    captchaSuccess?: boolean;
}

export class RegisterCustomerWithDetailsRequest implements IRegisterCustomerWithDetailsRequest {
    firstName?: string | undefined;
    lastName?: string | undefined;
    emailAddress?: string | undefined;
    password?: string | undefined;
    idNumber?: string | undefined;
    mobileNumber?: string | undefined;
    marketing?: boolean;
    includeVerification?: boolean;
    accountId?: string | undefined;
    captcha?: Captcha;

    constructor(data?: IRegisterCustomerWithDetailsRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.emailAddress = _data["emailAddress"];
            this.password = _data["password"];
            this.idNumber = _data["idNumber"];
            this.mobileNumber = _data["mobileNumber"];
            this.marketing = _data["marketing"];
            this.includeVerification = _data["includeVerification"];
            this.accountId = _data["accountId"];
            this.captcha = _data["captcha"] ? Captcha.fromJS(_data["captcha"]) : undefined as any;
        }
    }

    static fromJS(data: any): RegisterCustomerWithDetailsRequest {
        data = typeof data === 'object' ? data : {};
        let result = new RegisterCustomerWithDetailsRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["emailAddress"] = this.emailAddress;
        data["password"] = this.password;
        data["idNumber"] = this.idNumber;
        data["mobileNumber"] = this.mobileNumber;
        data["marketing"] = this.marketing;
        data["includeVerification"] = this.includeVerification;
        data["accountId"] = this.accountId;
        data["captcha"] = this.captcha ? this.captcha.toJSON() : undefined as any;
        return data;
    }
}

export interface IRegisterCustomerWithDetailsRequest {
    firstName?: string | undefined;
    lastName?: string | undefined;
    emailAddress?: string | undefined;
    password?: string | undefined;
    idNumber?: string | undefined;
    mobileNumber?: string | undefined;
    marketing?: boolean;
    includeVerification?: boolean;
    accountId?: string | undefined;
    captcha?: Captcha;
}

export class RegisterCustomerWithDetailsResponse implements IRegisterCustomerWithDetailsResponse {
    success?: boolean;
    status?: RegisterResponseStatusEnums;
    token?: string | undefined;
    accountId?: string | undefined;
    tokenExpiry?: string | undefined;
    captchaSuccess?: boolean;

    constructor(data?: IRegisterCustomerWithDetailsResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.success = _data["success"];
            this.status = _data["status"];
            this.token = _data["token"];
            this.accountId = _data["accountId"];
            this.tokenExpiry = _data["tokenExpiry"];
            this.captchaSuccess = _data["captchaSuccess"];
        }
    }

    static fromJS(data: any): RegisterCustomerWithDetailsResponse {
        data = typeof data === 'object' ? data : {};
        let result = new RegisterCustomerWithDetailsResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["success"] = this.success;
        data["status"] = this.status;
        data["token"] = this.token;
        data["accountId"] = this.accountId;
        data["tokenExpiry"] = this.tokenExpiry;
        data["captchaSuccess"] = this.captchaSuccess;
        return data;
    }
}

export interface IRegisterCustomerWithDetailsResponse {
    success?: boolean;
    status?: RegisterResponseStatusEnums;
    token?: string | undefined;
    accountId?: string | undefined;
    tokenExpiry?: string | undefined;
    captchaSuccess?: boolean;
}

export enum RegisterResponseStatusEnums {
    Unspecified = "Unspecified",
    EmailExists = "EmailExists",
    IdNumberExists = "IdNumberExists",
    IsSanctioned = "IsSanctioned",
    InvalidMobileNumber = "InvalidMobileNumber",
}

export enum ResponseStatusEnums {
    Unspecified = "Unspecified",
    IdNumberNotFound = "IdNumberNotFound",
    MultipleIdNumbersFound = "MultipleIdNumbersFound",
    CellNumberNotFound = "CellNumberNotFound",
    CellNumberInvalid = "CellNumberInvalid",
    OtpRequestLimitReached = "OtpRequestLimitReached",
}

export class UpdateAddressResponse implements IUpdateAddressResponse {
    addressUpdated?: boolean;

    constructor(data?: IUpdateAddressResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.addressUpdated = _data["addressUpdated"];
        }
    }

    static fromJS(data: any): UpdateAddressResponse {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateAddressResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["addressUpdated"] = this.addressUpdated;
        return data;
    }
}

export interface IUpdateAddressResponse {
    addressUpdated?: boolean;
}

export class UpdateAffordabilityResponse implements IUpdateAffordabilityResponse {
    affordabilityUpdated?: boolean;

    constructor(data?: IUpdateAffordabilityResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.affordabilityUpdated = _data["affordabilityUpdated"];
        }
    }

    static fromJS(data: any): UpdateAffordabilityResponse {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateAffordabilityResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["affordabilityUpdated"] = this.affordabilityUpdated;
        return data;
    }
}

export interface IUpdateAffordabilityResponse {
    affordabilityUpdated?: boolean;
}

export class UpdateBankResponse implements IUpdateBankResponse {
    bankUpdated?: boolean;

    constructor(data?: IUpdateBankResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.bankUpdated = _data["bankUpdated"];
        }
    }

    static fromJS(data: any): UpdateBankResponse {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateBankResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["bankUpdated"] = this.bankUpdated;
        return data;
    }
}

export interface IUpdateBankResponse {
    bankUpdated?: boolean;
}

export class UpdateContactResponse implements IUpdateContactResponse {
    contactUpdated?: boolean;

    constructor(data?: IUpdateContactResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.contactUpdated = _data["contactUpdated"];
        }
    }

    static fromJS(data: any): UpdateContactResponse {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateContactResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["contactUpdated"] = this.contactUpdated;
        return data;
    }
}

export interface IUpdateContactResponse {
    contactUpdated?: boolean;
}

export class UpdateCustomerResponse implements IUpdateCustomerResponse {
    customerUpdated?: boolean;
    isSanctioned?: boolean;

    constructor(data?: IUpdateCustomerResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.customerUpdated = _data["customerUpdated"];
            this.isSanctioned = _data["isSanctioned"];
        }
    }

    static fromJS(data: any): UpdateCustomerResponse {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateCustomerResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["customerUpdated"] = this.customerUpdated;
        data["isSanctioned"] = this.isSanctioned;
        return data;
    }
}

export interface IUpdateCustomerResponse {
    customerUpdated?: boolean;
    isSanctioned?: boolean;
}

export class UpdateEmploymentResponse implements IUpdateEmploymentResponse {
    employmentDetailsUpdated?: boolean;

    constructor(data?: IUpdateEmploymentResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.employmentDetailsUpdated = _data["employmentDetailsUpdated"];
        }
    }

    static fromJS(data: any): UpdateEmploymentResponse {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateEmploymentResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["employmentDetailsUpdated"] = this.employmentDetailsUpdated;
        return data;
    }
}

export interface IUpdateEmploymentResponse {
    employmentDetailsUpdated?: boolean;
}

export class UpdatePersonalDetailsResponse implements IUpdatePersonalDetailsResponse {
    addressUpdated?: boolean;
    bankUpdated?: boolean;
    contactUpdated?: boolean;
    customerUpdated?: boolean;
    employmentUpdated?: boolean;
    affordabilityUpdated?: boolean;

    constructor(data?: IUpdatePersonalDetailsResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.addressUpdated = _data["addressUpdated"];
            this.bankUpdated = _data["bankUpdated"];
            this.contactUpdated = _data["contactUpdated"];
            this.customerUpdated = _data["customerUpdated"];
            this.employmentUpdated = _data["employmentUpdated"];
            this.affordabilityUpdated = _data["affordabilityUpdated"];
        }
    }

    static fromJS(data: any): UpdatePersonalDetailsResponse {
        data = typeof data === 'object' ? data : {};
        let result = new UpdatePersonalDetailsResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["addressUpdated"] = this.addressUpdated;
        data["bankUpdated"] = this.bankUpdated;
        data["contactUpdated"] = this.contactUpdated;
        data["customerUpdated"] = this.customerUpdated;
        data["employmentUpdated"] = this.employmentUpdated;
        data["affordabilityUpdated"] = this.affordabilityUpdated;
        return data;
    }
}

export interface IUpdatePersonalDetailsResponse {
    addressUpdated?: boolean;
    bankUpdated?: boolean;
    contactUpdated?: boolean;
    customerUpdated?: boolean;
    employmentUpdated?: boolean;
    affordabilityUpdated?: boolean;
}

export class Uuid implements IUuid {
    value?: string | undefined;

    constructor(data?: IUuid) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.value = _data["value"];
        }
    }

    static fromJS(data: any): Uuid {
        data = typeof data === 'object' ? data : {};
        let result = new Uuid();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["value"] = this.value;
        return data;
    }
}

export interface IUuid {
    value?: string | undefined;
}

export class VerifyIdNumberRequest implements IVerifyIdNumberRequest {
    idNumber?: string | undefined;
    captcha?: Captcha;

    constructor(data?: IVerifyIdNumberRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.idNumber = _data["idNumber"];
            this.captcha = _data["captcha"] ? Captcha.fromJS(_data["captcha"]) : undefined as any;
        }
    }

    static fromJS(data: any): VerifyIdNumberRequest {
        data = typeof data === 'object' ? data : {};
        let result = new VerifyIdNumberRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["idNumber"] = this.idNumber;
        data["captcha"] = this.captcha ? this.captcha.toJSON() : undefined as any;
        return data;
    }
}

export interface IVerifyIdNumberRequest {
    idNumber?: string | undefined;
    captcha?: Captcha;
}

export class VerifyIdNumberResponse implements IVerifyIdNumberResponse {
    success?: boolean;
    status?: ResponseStatusEnums;
    accountId?: string | undefined;
    maskedCellNumber?: string | undefined;
    captchaSuccess?: boolean;

    constructor(data?: IVerifyIdNumberResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.success = _data["success"];
            this.status = _data["status"];
            this.accountId = _data["accountId"];
            this.maskedCellNumber = _data["maskedCellNumber"];
            this.captchaSuccess = _data["captchaSuccess"];
        }
    }

    static fromJS(data: any): VerifyIdNumberResponse {
        data = typeof data === 'object' ? data : {};
        let result = new VerifyIdNumberResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["success"] = this.success;
        data["status"] = this.status;
        data["accountId"] = this.accountId;
        data["maskedCellNumber"] = this.maskedCellNumber;
        data["captchaSuccess"] = this.captchaSuccess;
        return data;
    }
}

export interface IVerifyIdNumberResponse {
    success?: boolean;
    status?: ResponseStatusEnums;
    accountId?: string | undefined;
    maskedCellNumber?: string | undefined;
    captchaSuccess?: boolean;
}

export class ApiException extends Error {
    override message: string;
    status: number;
    response: string;
    headers: { [key: string]: any; };
    result: any;

    constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
        super();

        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }

    protected isApiException = true;

    static isApiException(obj: any): obj is ApiException {
        return obj.isApiException === true;
    }
}

function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): any {
    if (result !== null && result !== undefined)
        throw result;
    else
        throw new ApiException(message, status, response, headers, null);
}

/**
 * Configuration class needed in base class.
 * The config is provided to the API client at initialization time.
 * API clients inherit from #AuthorizedApiBase and provide the config.
 */
export class IConfig {
  private readonly logout: () => void;

  constructor(logout: () => void) {
    this.logout = logout;
  }

  onLogout = (): void => {
    this.logout();
  };

  getAuthorization = (): string | null => {
    const token = localStorage.getItem("token");
    return token ? `Bearer ${token}` : null;
  };
}